import React, { Dispatch, FC, SetStateAction } from 'react'
import { useThemeColors } from 'hooks/useThemeColors'
import { SearchBarWrapper } from './TableSearch.styles'
import { Box, IconButton, TextField } from '@mui/material'
import SearchWhiteIcon from '../../../components/svg/SearchWhiteIcon'
import ClearSvg from '../../../components/svg/ClearSvg'

interface Props {
  search: string
  setSearch: Dispatch<SetStateAction<string>>
}

const TableSearch: FC<Props> = ({ search, setSearch }) => {
  const getColor = useThemeColors()
  const inputHandler = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    setSearch(e.target.value)
  }

  return (
    <SearchBarWrapper>
      <Box className="search-icon">
        <SearchWhiteIcon />
      </Box>
      <TextField
        className="search-bar"
        value={search}
        placeholder={'Search...'}
        onInput={(e) => inputHandler(e)}
        onKeyDown={(e) => e.stopPropagation()}
        autoFocus={true}
        autoComplete="off"
      />
      {search && (
        <IconButton className="clear-btn" onClick={() => setSearch('')}>
          <ClearSvg color={getColor('text-primary')} />
        </IconButton>
      )}
    </SearchBarWrapper>
  )
}

export default TableSearch
